<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="商户管理">
      <template v-if="roleId == 1 || roleId == 9">
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="newlyAdded"
          >新增商户</el-button
        >
      </template>
      <template v-if="roleId == 2 || roleId == 3">
        <el-button
          size="small"
          icon="el-icon-edit"
          @click="editButton(addform)"
          type="primary"
          >编辑</el-button
        >
      </template>
    </pageTitle>
    <div style="padding: 20px" v-if="roleId == 2 || roleId == 3">
      <el-descriptions border title="用户信息">
        <el-descriptions-item
          label="商户名称"
          label-class-name="labelWidth"
          content-class-name="contentWidth"
          >{{ addform.name }}</el-descriptions-item
        >
        <el-descriptions-item
          label="商户简称"
          label-class-name="labelWidth"
          content-class-name="contentWidth"
          >{{ addform.short_name }}</el-descriptions-item
        >
        <el-descriptions-item
          label="状态"
          label-class-name="labelWidth"
          content-class-name="contentWidth"
        >
          <el-tag
            size="small"
            :type="addform.status == 0 ? 'success' : 'danger'"
            >{{ addform.status == 0 ? "启用" : "禁用" }}</el-tag
          >
        </el-descriptions-item>
        <el-descriptions-item
          label="商户级别"
          label-class-name="labelWidth"
          content-class-name="contentWidth"
        >
          {{
            addform.level == 0
              ? "盘商"
              : addform.level == 1
              ? "联营"
              : addform.level == 2
              ? "其它"
              : "--"
          }}
        </el-descriptions-item>
        <el-descriptions-item
          label="联系电话"
          label-class-name="labelWidth"
          content-class-name="contentWidth"
          >{{ addform.link_tel }}</el-descriptions-item
        >
        <el-descriptions-item
          label="联系人"
          label-class-name="labelWidth"
          content-class-name="contentWidth"
          >{{ addform.link_name }}</el-descriptions-item
        >
        <el-descriptions-item
          label="开票信息抬头"
          label-class-name="labelWidth"
          content-class-name="contentWidth"
          >{{ addform.company_title }}</el-descriptions-item
        >
        <el-descriptions-item
          label="纳税人识别号"
          label-class-name="labelWidth"
          content-class-name="contentWidth"
          >{{ addform.company_number }}</el-descriptions-item
        >
        <el-descriptions-item
          label="地址电话"
          label-class-name="labelWidth"
          content-class-name="contentWidth"
          >{{ addform.address_tel }}</el-descriptions-item
        >
        <el-descriptions-item
          label="银行账号"
          label-class-name="labelWidth"
          content-class-name="contentWidth"
          >{{ addform.bank_number }}</el-descriptions-item
        >
        <el-descriptions-item
          label="商户logo"
          label-class-name="labelWidth"
          content-class-name="contentWidth"
        >
          <el-image
            style="width: auto; height: 75px"
            :src="addform.logo"
          ></el-image>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <basicList v-else :config="basicListconfig" @search="searchEvent">
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div class="button button_modify" @click="editButton(row.row)">
            <i class="iconfont icon-bianji"></i> 编辑
          </div>

          <template v-if="roleId == 1 || roleId == 9">
            <div class="button button_revoke" @click="switchingStates(row.row)">
              <i
                :class="
                  row.row.status == 0
                    ? 'iconfont icon-lock'
                    : 'iconfont icon-jihuo'
                "
              ></i
              >{{ row.row.status == 0 ? "锁定" : "激活" }}
            </div>
          </template>

          <template v-if="roleId == 1 || roleId == 9">
            <div class="button button_revoke" @click="deleteRows(row.row)">
              <i class="iconfont icon-shanchu"></i> 删除
            </div>
          </template>

          <template v-if="roleId == 1 || roleId == 9">
            <div class="button button_revoke" @click="LoginRows(row.row)">
              <i class="iconfont icon-shanchu"></i> 浏览
            </div>
          </template>

          <!-- <el-popover
            :visible-arrow="false"
            placement="bottom"
            width="160"
            trigger="click"
          >
            <ul class="moreOperations">
              <li @click="activation(row.row)">
                <i class="iconfont icon-jihuo"></i> 激活
              </li>
              <li @click="deleteRows(row.row)">
                <i class="iconfont icon-shanchu"></i> 删除
              </li>
            </ul>
            <div slot="reference" class="button button_more">
              <img src="../../assets/images/icon_more.png" />
            </div>
          </el-popover> -->
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
  </div>
</template>

<script>
import { superLogin } from "@/api/base";
import {
  companyGetlist,
  companydel,
  companyactive,
  companyLock,
  companyGetOne,
} from "@/api/basicConfiguration";
import store from "@/store";
import { setSession, setRoles } from "@/utils";

// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "franchiseManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      roleId: 0,
      addform: {},
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        search: [
          {
            label: "加盟时间",
            type: "daterange",
            key: "join_time",
          },
          {
            label: "编号",
            type: "inputNumber",
            key: "id",
            width: 100,
          },
          {
            label: "名称/联系人/联系电话",
            type: "input",
            key: "keywords",
          },

          {
            label: "状态",
            key: "status",
            type: "select",
            options: [
              {
                label: "启用",
                value: 0,
              },
              {
                label: "禁用",
                value: 1,
              },
            ],
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            width: 100,
          },
          {
            label: "商户名称",
            prop: "name",
            width: 200,
          },
          {
            label: "联系人",
            prop: "link_name",
          },
          {
            label: "联系电话",
            prop: "link_tel",
            width: 120,
          },
          {
            label: "总资产",
            prop: "total_fee",
            isMoney: true,
            width: 120,
          },
          {
            label: "库存",
            prop: "item_fee",
            isMoney: true,
            width: 120,
          },
          {
            label: "现金",
            prop: "cash",
            isMoney: true,
            width: 120,
          },
          {
            label: "应付",
            prop: "payable_fee",
            isMoney: true,
            width: 120,
          },
          {
            label: "应收",
            prop: "receivable_fee",
            isMoney: true,
            width: 120,
          },
          {
            label: "客户预存",
            prop: "prepay_fee",
            isMoney: true,
            width: 120,
          },
          {
            label: "加盟时间",
            prop: "join_time",
            width: 180,
          },
          {
            label: "状态",
            prop: "status",
            filter: "merchantStatus",
          },
        ],
        isPage: true,
        operationWidth: 300,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.shopId = this.$store.getters.userInfo.shopId;

    // 门店管理中：商户只能编辑基础信息
    this.roleId = this.$store.getters.userRole;
    this.compId = this.$store.getters.userInfo.compId;

    // 初始化列表内容
    if (this.roleId == 2 || this.roleId == 3) {
      this.getDetails(this.compId);
    } else {
      this.getlist();
    }
  },
  methods: {
    getDetails(id) {
      companyGetOne({ id: id }).then((res) => {
        if (res.code == 1) {
          this.addform = res.data[0];
        } else {
          this.$message.error(res.data.msg || "获取失败！");
        }
        console.log(
          "%c [  ]-245",
          "font-size:13px; background:pink; color:#bf2c9f;",
          res
        );
      });
    },
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 锁定方法
    locking(row) {
      this.$confirm("是否确认锁定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        companyLock({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 激活方法
    activation(row) {
      this.$confirm("是否确认激活?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        companyactive({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        companydel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    LoginRows(row) {
      this.$confirm(
        "你将以该 " + row.short_name + " 商户超管身份切换登录, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        // 获取当前页面的URL
        let currentUrl = window.location.href;

        // 解析当前URL，获取协议、主机名和端口
        let parser = document.createElement("a");
        parser.href = currentUrl;

        // 构造新的URL，保持协议、主机名和端口不变，路由改为/login
        // let newUrl =
        // parser.protocol +
        // "//" +
        // parser.host +
        // "/#/login?user_id=" +
        // this.userId +
        // "&comp_id=" +
        // row.id;
        let newUrl =
          "http://47.100.124.64/admin/login/sudo?user_id=" +
          this.userId +
          "&comp_id=" +
          row.id;
        // 使用window.open()打开新窗口
        // let newWindow = window.open(newUrl, "_blank");

        // // 该操作会在后台自动执行登出、登入操作，切换商户ID为所传comp_id
        superLogin({
          user_id: this.userId,
          comp_id: row.id,
        }).then((res) => {
          if (res.code == 1) {
            // 后台返回:用户ID、名字；角色ID、名字；商户ID、名字
            // 1、存入 cookie
            setRoles(JSON.stringify(res.data));
            // 2、存入 Vuex
            store.dispatch("fetchUserInfo", res.data);
            // 3、通知 store 拉后台基础数据，包括用户权限表
            store.dispatch("fetchBackendData");

            // 解析 ci_session 值, TODO: 之后改 TOKEN 方案后去掉
            let session_id = res.data.session_id;
            if (session_id) {
              // expired_time = // 后台返回 SESSION 过期时间，当前后台设默认值 2 小时
              setSession(session_id, 1); // 存储 1 天
            }

            this.$router.push("/");
            // this.cleartagsviews();
          } else {
            this.$message.error(res.data.msg || "退出登录失败！");
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      if (this.roleId == 2 || this.roleId == 3) {
        this.getDetails(this.addform.id);
      } else {
        this.getlist();
      }
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page) {
      if (page) {
        this.basicListconfig.page = page;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      // 非平台超管只能看到自己
      if (this.roleId != 1 && this.roleId != 9) {
        this.basicListconfig.searchParameters.comp_id = this.compId;
      }
      this.basicListconfig.searchParameters.is_showAll = 1;
      companyGetlist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style>
.labelWidth {
  width: 200px;
}
.contentWidth {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/franchiseManagement/index.vue